<template>
  <div class="h-8 w-full rounded-3xl parent p-1" v-bind="$attrs">
    <div
      class="child bg-success h-full rounded-3xl relative"
      :style="{ width: pourcent + '%' }"
    >
      <img src="@/assets/img/progress.png" alt="" class="h-full w-full" />
      <div
        style="background-color:#34775C"
        class="w-12 h-full absolute top-0 rounded-xl right-0 text-white font-bold flex items-center justify-center"
      >
        {{ pourcent }}%
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  props: {
    pourcent: {
      type: Number,
      default: 0
    }
  }
})
</script>

<style scoped>
.parent {
  background: #efffe6;
  box-shadow: inset -1.17647px 2.35294px 7.05882px rgba(82, 90, 85, 0.3);
}

.child {
  border: 3px solid #149e36;
}
</style>
